module.exports = __webpack_public_path__ + "images/emoji/ophiuchus.84bfea79702d7f62290f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ophiuchus.png
// module id = XxdH
// module chunks = 14